export const SET_PROGRAMS_LIST = 'programs/SET_PROGRAMS_LIST'
export const SET_MANAGE_PROGRAM = 'programs/SET_MANAGE_PROGRAM'
export const UPDATE_ACTIVE_PROGRAM = 'programs/UPDATE_ACTIVE_PROGRAM'
